export enum TrackingCodeNameEnum {
  ARR = "Arrived",
  DLV = "Delivered",
  DDL = "Documents Delivered",
  RCV = "Received",
  DEP = "Departed",
  MAN = "Manifested",
  BKC = "Booking Confirmed",
  BKD = "Booked",
  RCS = "Received from Shipper",
  RCF = "Received from Flight",
  NFD = "Consignee Notified",
  FOH = "Freight on hand",
  AWD = "Documentation Delivered",
  CLD = "Cargo Loaded",
  PRE = "Shipment Prepared",
  ARV = "Arrived",
  FWB = "Electronic AWB",
  TRA = "In Transit",
  AWR = "Documents Received",
  TFD = "Transferred",
  RCT = "Received from other airline",
  SCW = "Shipment Checked Into Warehouse",
  CLC = "Cleared by Customs",
  TPL = "Temperature Log",
}
